import { Link } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";

const navigation = {
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61570213181020",
      icon: (props) => (
        <img
          alt="Facebook"
          width="32"
          height="32"
          src="https://content.qeeb.in/coltec/facebook-icon.png"
          {...props}
        />
      ),
    },
    {
      name: "Youtube",
      href: "https://www.youtube.com/@coltecglobal5339",
      icon: (props) => (
        <img
          alt="Youtube"
          width="32"
          height="32"
          src="https://content.qeeb.in/coltec/youtube-icon.svg"
          {...props}
        />
      ),
    },
    {
      name: "X",
      href: "https://x.com/ColtecGlobal",
      icon: (props) => (
        <img
          alt="Twitter"
          width="32"
          height="32"
          src="https://content.qeeb.in/coltec/twitter-icon.png"
          {...props}
        />
      ),
    },
    {
      name: "Pinterest",
      href: "https://in.pinterest.com/05bzyue3rn9tm33slqgsnsv6lixofq/",
      icon: (props) => (
        <img
          alt="Pinterest"
          width="32"
          height="32"
          src="https://content.qeeb.in/coltec/pinterest-icon.svg"
          {...props}
        />
      ),
    },
    {
      name: "LinkedIn",
      href: "https://www.linkedin.com/company/coltec-global/",
      icon: (props) => (
        <img
          alt="LinkedIn"
          width="32"
          height="32"
          src="https://content.qeeb.in/coltec/linkedin-icon.png"
          {...props}
        />
      ),
    },
  ],
};

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year
  return (
    <footer aria-labelledby="footer-heading" className="bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-8 md:pt-16 lg:px-8 lg:pt-16 landing-footer">
        <div className="xl:grid xl:grid-cols-12 xl:gap-4">
          <div className="col-span-6">
            <div className="xl:grid xl:grid-cols-12 grid-cols-2 md:grid-cols-4 grid xl:gap-0">
              <div className="xl:col-span-2 space-y-2">
                <div>
                  <Link
                    to="/"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Home
                  </Link>
                </div>
                <div>
                  <Link
                    to="/about-us"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    About Us
                  </Link>
                </div>
                <div>
                  <Link
                    to="/media"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Media
                  </Link>
                </div>
                <div>
                  <Link
                    to="/connect"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Connect
                  </Link>
                </div>
                <div>
                  <Link
                    to="/shop"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Products
                  </Link>
                </div>
                <div>
                  <Link
                    to="/solutions/education"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Solutions
                  </Link>
                </div>
                <div>
                  <Link
                    to="/blogs"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Blogs
                  </Link>
                </div>
              </div>
              <div className="xl:col-span-4 space-y-2">
                <div>
                  <Link
                    to="/privacy-policy"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Privacy Policy
                  </Link>
                </div>
                <div>
                  <Link
                    to="/cookies-policy"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Cookies policy
                  </Link>
                </div>
                <div>
                  <Link
                    to="/terms-of-use"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Terms of Use
                  </Link>
                </div>
                <div>
                  <Link
                    to="/e-waste-policy"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    E-Waste Policy
                  </Link>
                </div>
                <div>
                  <Link
                    to="/refund-return-policy"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Refund & Return Policy
                  </Link>
                </div>
              </div>
              <div className="xl:col-span-4 md:space-y-2 space-y-2 xl:pt-0 pt-4">
                <h3 className="text-yellow-500 md:text-[13px] text-xs font-medium">
                  Popular Products
                </h3>
                <div>
                  <Link
                    to="/coltec-smart-interactive-flat-panel-for-classroom"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Interactive Flat Panel for School
                  </Link>
                </div>
                <div>
                  <Link
                    to="/products/active-led/inertia-series"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Active LED Video Wall
                  </Link>
                </div>
                <div>
                  <Link
                    to="/products/commercial-display/vista-series"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Commercial Display
                  </Link>
                </div>
              </div>
              <div className="xl:col-span-2 space-y-2 xl:pt-0 pt-4 pl-8 lg:pl-0">
                <h3 className="text-yellow-500 md:text-[13px] text-xs font-medium">
                  Quick Links
                </h3>
                <div>
                  <Link
                    to="/book-a-demo"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Request Demo
                  </Link>
                </div>
                <div>
                  <Link
                    to="/get-a-quote"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Request Quote
                  </Link>
                </div>
                <div className="whitespace-nowrap">
                  <Link
                    to="/download"
                    className="text-gray-300 md:text-[13px] text-xs hover:text-white"
                  >
                    Download Center
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-6">
            <div className="flex flex-col lg:flex-row lg:pl-8">
              <div className="mt-6 xl:mt-0">
                <div className="md:text-[13px] text-xs leading-6 text-gray-300 mb-2">
                  <p className="text-white font-medium mb-1">Design Office</p>
                  <p>
                    1014 - 155 Hillcrest Avenue, Mississauga, <br />
                    Canada ON L5B 3Z2
                  </p>
                </div>
                <p className="md:text-[13px] text-xs md:leading-6 text-gray-300 mb-4">
                  +1 (647) 564-6779
                </p>
              </div>
              <div className="lg:pl-14 xl:pt-0 md:pt-5">
                <div className="md:text-[13px] text-xs leading-5 md:leading-6 text-gray-300 mb-2">
                  <p className="text-white font-medium mb-2">
                    Manufacturing and Regional Office
                  </p>
                  Survey No.75/A Gagan Pahad, Rajendra Nagar Municipality Ranga
                  Reddy District, TS INDIA
                </div>
                <p className="md:text-[13px] text-xs md:leading-6 text-gray-300 mb-2">
                  +91 1800 309 8822
                </p>
                <p className="md:text-[13px] text-xs md:leading-6 text-gray-300 mb-4">
                  sales@coltec-global.com
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex md:flex-row md:justify-between flex-wrap md:items-center mt-5 sm:mt-10">
          <div className="md:flex grid grid-cols-2 gap-3 md:space-x-4">
            <Link
              to="https://www.amazon.in/storefront?me=A2Y3Q4IRLWFHHS&ref_=ssf_share"
              target="_blank"
            >
              <img
                alt="amazon-marketplace"
                className="h-[48px]"
                src="https://content.qeeb.in/coltec/img/amazon-marketplace.webp"
              />
            </Link>
            <Link to="https://www.indiamart.com/obssolutions/" target="_blank">
              <img
                alt="indiamart"
                className="h-[48px]"
                src="https://content.qeeb.in/coltec/img/indiamart.webp"
              />
            </Link>
            <div>
              <img
                alt="gem-marketplace"
                className="h-[48px] w-full"
                src="https://content.qeeb.in/coltec/img/gem-marketplace.webp"
              />
            </div>
            <div>
              <img
                alt="make-india"
                className="h-[48px] w-full"
                src="https://content.qeeb.in/coltec/img/make-india.webp"
              />
            </div>
          </div>
          <div className="pt-3 lg:pt-0">
            <p className="text-sm text-white mb-1">
              Subscribe to our Newsletter
            </p>
            <div className="relative">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                className="md:w-96 w-80 max-w-96 md:h-9 h-10 bg-white rounded text-sm"
              />
              <button className="flex items-center text-white absolute right-1 top-0.5 px-5 text-sm w-32 h-9 md:h-[31px] bg-neutral-950 rounded">
                Submit <FaArrowRightLong className="ml-5" />
              </button>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mt-5 border-t border-white/30 pt-5 sm:mt-10">
          <div className="mb-2 lg:mb-0">
            <Link>
              <img
                alt="footer-coltec-logo"
                className="md:h-[24px] h-[20px]"
                src="https://content.qeeb.in/coltec/img/footer-coltec-logo.webp"
              />
            </Link>
          </div>
          <p className="md:text-sm text-xs leading-5 text-gray-400 mb-2 lg:mb-0">
            &copy; {currentYear} Coltec Global All rights reserved.
          </p>
          <div className="flex space-x-6">
            {navigation.social.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                rel="noreferrer"
                className="text-gray-500 hover:text-gray-400"
              >
                <span className="sr-only">{item.name}</span>
                <item.icon aria-hidden="true" className="h-6 w-6" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
